import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, mergeProps as _mergeProps, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "edit_company_setting_modal",
  tabindex: "-1",
  "aria-hidden": "true",
  ref: "editCompanySettingModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-850px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "edit_company_setting_modal_header"
}
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "edit_company_setting_modal_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#edit_company_setting_modal_header",
  "data-kt-scroll-wrappers": "#edit_company_setting_modal_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_8 = { class: "fv-row mb-7" }
const _hoisted_9 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "fv-row mb-7" }
const _hoisted_13 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "fv-row mb-7" }
const _hoisted_18 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_19 = { class: "required" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "fv-row mb-7" }
const _hoisted_26 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "fv-plugins-message-container" }
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { class: "fv-row mb-7" }
const _hoisted_31 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_32 = { class: "d-flex align-items-center mt-3" }
const _hoisted_33 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_34 = ["aria-label"]
const _hoisted_35 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_36 = { class: "form-check form-check-inline form-check-solid" }
const _hoisted_37 = ["aria-label"]
const _hoisted_38 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_39 = { class: "fv-row mb-7" }
const _hoisted_40 = { class: "required fs-6 fw-bold mb-2" }
const _hoisted_41 = { class: "d-flex align-items-center mt-3" }
const _hoisted_42 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_43 = ["aria-label"]
const _hoisted_44 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_45 = { class: "form-check form-check-inline form-check-solid" }
const _hoisted_46 = ["aria-label"]
const _hoisted_47 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_48 = { class: "fv-row mb-7" }
const _hoisted_49 = { class: "col-lg-4 required col-form-label fw-bold fs-6" }
const _hoisted_50 = { class: "fv-row" }
const _hoisted_51 = { class: "d-flex mt-3 flex-column" }
const _hoisted_52 = { class: "form-check form-check-inline form-check-solid me-5" }
const _hoisted_53 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_54 = { class: "form-check form-check-inline form-check-solid mt-1" }
const _hoisted_55 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_56 = { class: "form-check form-check-inline form-check-solid mt-1" }
const _hoisted_57 = { class: "fw-bold ps-2 fs-6" }
const _hoisted_58 = { class: "fv-plugins-message-container" }
const _hoisted_59 = { class: "fv-help-block" }
const _hoisted_60 = { class: "modal-footer flex-end" }
const _hoisted_61 = ["data-kt-indicator"]
const _hoisted_62 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_63 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_64 = {
  key: 1,
  class: "indicator-progress"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.translate("EDIT_COMPANY_SETTINGS_MODAL_TITLE")), 1)
        ]),
        (_ctx.currentCustomer && _ctx.selectLists && _ctx.currentYearlyParameters)
          ? (_openBlock(), _createBlock(_component_Form, {
              key: 0,
              id: "kt_change_password",
              class: "form",
              novalidate: "novalidate",
              onSubmit: _ctx.submit,
              "validation-schema": _ctx.editCompanySettingSchema
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.translate("CHANGE_DENOMINATION_LABEL")), 1),
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "denom",
                        class: "form-control form-control-lg",
                        placeholder: "Company name",
                        modelValue: _ctx.currentCustomer.denom,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentCustomer.denom) = $event)),
                        "aria-label": _ctx.translate('CHANGE_DENOMINATION_LABEL')
                      }, null, 8, ["modelValue", "aria-label"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_ErrorMessage, { name: "denom" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate("CHANGE_SETTORE_LABEL")), 1),
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "settore",
                        class: "form-select form-select-solid form-select-lg",
                        modelValue: _ctx.currentYearlyParameters.azienda_yearly_parameters.settore,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.settore) = $event)),
                        "aria-label": _ctx.translate('CHANGE_SETTORE_LABEL')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.settori, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id,
                              key: index
                            }, [
                              _createElementVNode("b", null, _toDisplayString(item[_ctx.translateKey("descrizione")]), 1)
                            ], 8, _hoisted_14))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "aria-label"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_ErrorMessage, { name: "settore" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate("CHANGE_FATTURATO_LABEL")), 1)
                      ]),
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "fatturato",
                        class: "form-select form-select-solid form-select-lg",
                        modelValue: _ctx.currentYearlyParameters.azienda_yearly_parameters.fatturato,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.fatturato) = $event)),
                        "aria-label": _ctx.translate('CHANGE_FATTURATO_LABEL')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.fatturati, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.id,
                              key: index
                            }, [
                              (_ctx.locale === 'it')
                                ? (_openBlock(), _createElementBlock("b", _hoisted_21, _toDisplayString(item.descrizione), 1))
                                : (_openBlock(), _createElementBlock("b", _hoisted_22, _toDisplayString(item.descrizione_en), 1))
                            ], 8, _hoisted_20))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "aria-label"]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_ErrorMessage, { name: "fatturato" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate("CHANGE_EMPLOYEES_RANGE")), 1),
                      _createVNode(_component_Field, {
                        as: "select",
                        name: "employees_range",
                        class: "form-select form-select-solid form-select-lg",
                        modelValue: _ctx.currentYearlyParameters.azienda_yearly_parameters.employees_range,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.employees_range) = $event)),
                        "aria-label": _ctx.translate('CHANGE_EMPLOYEES_RANGE')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectLists.employee_range, (item, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: item.range_id,
                              key: index
                            }, [
                              _createElementVNode("b", null, _toDisplayString(item.description), 1)
                            ], 8, _hoisted_27))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "aria-label"]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_ErrorMessage, { name: "employees_range" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.translate("CHANGE_ASSOCIATED_STATUS_QUESTION")), 1),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("label", _hoisted_33, [
                          _createVNode(_component_Field, {
                            name: "is_associated",
                            value: 1
                          }, {
                            default: _withCtx(({ field }) => [
                              _withDirectives(_createElementVNode("input", _mergeProps({
                                type: "radio",
                                class: "form-check-input",
                                name: "is_associated"
                              }, field, {
                                value: 1,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.is_associated) = $event)),
                                "aria-label": _ctx.translate('CHANGE_ASSOCIATED_OPTION')
                              }), null, 16, _hoisted_34), [
                                [_vModelRadio, _ctx.currentYearlyParameters.azienda_yearly_parameters.is_associated]
                              ])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.translate("CHANGE_ASSOCIATED_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_36, [
                          _createVNode(_component_Field, {
                            name: "is_associated",
                            value: 0
                          }, {
                            default: _withCtx(({ field }) => [
                              _withDirectives(_createElementVNode("input", _mergeProps({
                                type: "radio",
                                class: "form-check-input",
                                name: "is_associated"
                              }, field, {
                                value: 0,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.is_associated) = $event)),
                                "aria-label": _ctx.translate('CHANGE_NOT_ASSOCIATED_OPTION')
                              }), null, 16, _hoisted_37), [
                                [_vModelRadio, _ctx.currentYearlyParameters.azienda_yearly_parameters.is_associated]
                              ])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.translate("CHANGE_NOT_ASSOCIATED_OPTION")), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.translate("CHANGE_QUOTED_STATUS_QUESTION")), 1),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("label", _hoisted_42, [
                          _createVNode(_component_Field, {
                            name: "is_quoted",
                            value: 1
                          }, {
                            default: _withCtx(({ field }) => [
                              _withDirectives(_createElementVNode("input", _mergeProps({
                                type: "radio",
                                class: "form-check-input",
                                name: "is_quoted"
                              }, field, {
                                value: 1,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.is_quoted) = $event)),
                                "aria-label": _ctx.translate('CHANGE_QUOTED_OPTION')
                              }), null, 16, _hoisted_43), [
                                [_vModelRadio, _ctx.currentYearlyParameters.azienda_yearly_parameters.is_quoted]
                              ])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.translate("CHANGE_QUOTED_OPTION")), 1)
                        ]),
                        _createElementVNode("label", _hoisted_45, [
                          _createVNode(_component_Field, {
                            name: "is_quoted",
                            value: 0
                          }, {
                            default: _withCtx(({ field }) => [
                              _withDirectives(_createElementVNode("input", _mergeProps({
                                type: "radio",
                                class: "form-check-input",
                                name: "is_quoted"
                              }, field, {
                                value: 0,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.is_quoted) = $event)),
                                "aria-label": _ctx.translate('CHANGE_NOT_QUOTED_OPTION')
                              }), null, 16, _hoisted_46), [
                                [_vModelRadio, _ctx.currentYearlyParameters.azienda_yearly_parameters.is_quoted]
                              ])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.translate("CHANGE_NOT_QUOTED_OPTION")), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.translate("CHANGE_COMPANY_TYPE_QUESTION")), 1),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("label", _hoisted_52, [
                            _createVNode(_component_Field, {
                              type: "radio",
                              class: "form-check-input",
                              name: "company_type",
                              value: "D01",
                              modelValue: _ctx.currentYearlyParameters.azienda_yearly_parameters.company_type,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.company_type) = $event)),
                              "aria-label": _ctx.translate('CHANGE_PMI_OPTION')
                            }, null, 8, ["modelValue", "aria-label"]),
                            _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.translate("CHANGE_PMI_OPTION")), 1)
                          ]),
                          _createElementVNode("label", _hoisted_54, [
                            _createVNode(_component_Field, {
                              type: "radio",
                              class: "form-check-input",
                              name: "company_type",
                              value: "D02",
                              modelValue: _ctx.currentYearlyParameters.azienda_yearly_parameters.company_type,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.company_type) = $event)),
                              "aria-label": _ctx.translate('CHANGE_SMALL_OPTION')
                            }, null, 8, ["modelValue", "aria-label"]),
                            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.translate("CHANGE_SMALL_OPTION")), 1)
                          ]),
                          _createElementVNode("label", _hoisted_56, [
                            _createVNode(_component_Field, {
                              type: "radio",
                              class: "form-check-input",
                              name: "company_type",
                              value: "D03",
                              modelValue: _ctx.currentYearlyParameters.azienda_yearly_parameters.company_type,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentYearlyParameters.azienda_yearly_parameters.company_type) = $event)),
                              "aria-label": _ctx.translate('CHANGE_LARGE_OPTION')
                            }, null, 8, ["modelValue", "aria-label"]),
                            _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.translate("CHANGE_LARGE_OPTION")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createVNode(_component_ErrorMessage, { name: "company_type" })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("button", {
                    type: "button",
                    id: "edit_company_setting_modal_cancel",
                    class: "btn btn-white",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                  }, _toDisplayString(_ctx.translate("BUTTON_CLOSE")), 1),
                  _createElementVNode("button", {
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    class: "btn btn-dark-blue",
                    type: "submit"
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                          _createTextVNode(_toDisplayString(_ctx.translate("BUTTON_SUBMIT")) + " ", 1),
                          _createElementVNode("span", _hoisted_63, [
                            _createVNode(_component_inline_svg, {
                              src: "icons/duotune/arrows/arr064.svg",
                              "aria-hidden": "true"
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_64, [...(_cache[12] || (_cache[12] = [
                          _createTextVNode(" Please wait... ", -1),
                          _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_61)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}